import axios from "axios";

/**
 * @param url The URL of the file to fetch and convert to an object URL.
 * @description Fetches a file from the given URL and converts it to an object URL (created using URL.createObjectURL).
 * @returns A promise that resolves to the object URL of the fetched file.
 */
export const toObjectUrl = async (url: string): Promise<string> => {
  const resp = await axios.get<Blob>(url, {
    responseType: "blob",
  });
  if (resp.status === 200) {
    return URL.createObjectURL(resp.data);
  }

  throw new Error("Failed to fetch the file");
};
